import { ANIMATION_DURATION, TRANSITION_DELAY } from '@/constants/register.contants'
import { TypewriterText } from '@/shared/components/Typewriter/TypewriterText'
import { Grow, Paper, useTheme } from '@mui/material'
import React, { useRef } from 'react'

export const InterestMessage: React.FC<InterestMessageProps> = ({ userName, onAnimationComplete }) => {
  const animationCompleteRef = useRef(false)
  const theme = useTheme()

  const handleEntered = () => {
    if (!animationCompleteRef.current) {
      animationCompleteRef.current = true
      setTimeout(onAnimationComplete, TRANSITION_DELAY)
    }
  }

  return (
    <Grow in={true} timeout={ANIMATION_DURATION} onEntered={handleEntered}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 1,
          borderRadius: 4,
          borderColor: 'divider',
          borderStyle: 'solid',
        }}
      >
        <TypewriterText
          variant="body1"
          color="text.primary"
          text={`Awesome, ${userName}! 🎉 Could you also share why you are excited about joining the Risk Analytics Explorer Community? Select all that apply or share your own thoughts or examples:`}
          highlightColor={theme.palette.error.dark}
          delay={5}
        />
      </Paper>
    </Grow>
  )
}
